import React , {useState, useEffect} from "react";
import DashboardComponent from "../../component/dashboard/Dashboard";
import { supabase } from "../../utils/supabase";
import { Store } from 'react-notifications-component'
import "../../assets/styles/HomePageSettings.scss";
import Primary from "../../assets/images/themes/default.png"
import Spooky from "../../assets/images/themes/spooky.png"
import Christmas from "../../assets/images/themes/christmas.png"
import Candyland from "../../assets/images/themes/candyland.png"

export default function ThemeSelection(){
    const [theme, setTheme] = useState();
    //const [currImage, setCurrImage] = useState('');

    const [file, setFile] = useState();
 
    const [uploading, setUploading] = useState(false);
    const [uploadedUrl, setUploadedUrl] = useState("");

    const getSavedTheme = async () => {
        const { data } = await supabase
        .from('theme')        
        .select()
        .eq("status", true);        
        if(data[0]?.theme){
            setTheme(data[0]);
        }
    }


    const getFlePublicUrl = async () => {
        if(theme?.background){
            
            // const { data } = await supabase
            //     .storage
            //     .from('vpscorecard')
            //     .getPublicUrl( theme.background );

            // if(data && data.publicUrl){              
            //     setCurrImage(data?.publicUrl)
            // }

            
        }
        
    }

    const getThemeImage = async (themeName) => {
        const { data, error:getError } = await supabase
        .storage
        .from("vpscorecard")
        .list("", {
            limit: 1,            // get only the newest one
            sortBy: { column: "created_at", order: "desc" } // newest first
        });

        if (getError) {
        console.error("Error listing files:", getError);
        return;
        }

        if (data && data.length > 0) {
            const latestFile = data[0].name;

            // Now get a public URL for this latest file
            const { data: urlData } = supabase
                .storage
                .from("vpscorecard")
                .getPublicUrl(latestFile);

            setUploadedUrl(urlData.publicUrl);
        }
    }


    useEffect(()=>{
        getSavedTheme();
        getThemeImage();
    },[])

    useEffect(()=>{        
        getFlePublicUrl()
        // eslint-disable-next-line
    },[theme]) 

    const saveTheme = async () => { 

             //set previous active theme to false
             await supabase
               .from('theme')
               .update({ status: false })
               .eq('status', 'true')
               .select();
        

            const { data:newTheme } = await supabase
            .from('theme')
            .update({ 
                status: true,
                show_logo: theme.show_logo !== false,
                show_title: theme.show_title !== false
            })
            .eq('theme', theme.theme)
            .select()

            if(file?.name){
                const { data:imageData} = await supabase
                .storage
                .from('vpscorecard')
                .upload(file.name, file, {
                    cacheControl: '0',
                    upsert: true
                })                

                const {data:afterImageUpdate} = await supabase
                    .from('theme')
                    .update({ background: imageData.path  })
                    .eq('theme', theme.theme)
                    .select()
                    setTheme(afterImageUpdate[0])
            }
            
            
            if(newTheme){
                Store.addNotification({
                    title: "Success!",
                    message: 'Theme Updated successfully',
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true,
                        click: true,
                        showIcon: true,
                        pauseOnHover: true
                    }
                });
            }
            
    }


    const saveImage = async () => {
        if (!file) {
            alert("Please select an image first.");
            return;
        }

        try {
            setUploading(true);

            // Give each file a unique name to avoid overwriting
            const fileExt = file.name.split(".").pop();
            const fileName = `${Date.now()}.${fileExt}`;

            // Upload to a bucket called "images"
            const { error } = await supabase.storage
                .from("vpscorecard")
                .upload(fileName, file);

            if (error) throw error;

            // Get the public URL (if your bucket is set to public)
            const { data, error:getError } = await supabase
                .storage
                .from("vpscorecard")
                .list("", {
                    limit: 1,            // get only the newest one
                    sortBy: { column: "created_at", order: "desc" } // newest first
                });

                if (getError) {
                console.error("Error listing files:", getError);
                return;
                }

                if (data && data.length > 0) {
                    const latestFile = data[0].name;

                    // Now get a public URL for this latest file
                    const { data: urlData } = supabase
                        .storage
                        .from("vpscorecard")
                        .getPublicUrl(latestFile);

                    setUploadedUrl(urlData.publicUrl);
                }

            alert("Upload successful!");
        } catch (err) {
            console.error("Upload failed:", err.message);
            alert("Error uploading image: " + err.message);
        } finally {
            setUploading(false);
        }
    };


    return <DashboardComponent>
            <div className="container_home_settings">
                <h3>Theme Selection</h3>
                 
                <table>
                    <tbody>
                        <tr>
                            <td>Select Theme: </td>
                            <td> </td>
                            <td> 
                                <select value={theme?.theme} onChange={(e)=>setTheme(prev => ({...prev, theme: e.target.value}))}>
                                    <option value="default">Default</option>
                                    <option value="spooky">Spooky</option>
                                    <option value="christmas">Christmas</option>
                                    <option value="candyland">Candyland</option>
                                </select><br/>
                                <input type="button" value={"Save theme selection"} onClick={()=>saveTheme()}/>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Show Victoria Park Logo:</td>
                            <td></td>
                            <td>
                                <input 
                                    type="checkbox" 
                                    checked={theme?.show_logo !== false} 
                                    onChange={(e) => setTheme(prev => ({...prev, show_logo: e.target.checked}))}
                                />
                                <label style={{marginLeft: "10px"}}>
                                    {theme?.show_logo !== false ? "Visible" : "Hidden"}
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Show PUTT PUTT SCORECARD Title:</td>
                            <td></td>
                            <td>
                                <input 
                                    type="checkbox" 
                                    checked={theme?.show_title !== false} 
                                    onChange={(e) => setTheme(prev => ({...prev, show_title: e.target.checked}))}
                                />
                                <label style={{marginLeft: "10px"}}>
                                    {theme?.show_title !== false ? "Visible" : "Hidden"}
                                </label>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr style={{height:"50px"}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Select Home Image:</td>
                             <td></td>
                            <td>
                                 <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setFile(e.target.files[0])}
                                /><br/>
                                <input
                                    type="button"
                                    value={uploading ? "Uploading..." : "Save Image Selection"}
                                    onClick={saveImage}
                                    disabled={uploading}
                                    style={{ }}
                                />
                            </td>
                            <td>
                                <p>Current active image</p>
                                <img style={{width: "100px"}} src={uploadedUrl} alt="Current"/>
                            </td>
                            <td></td>
                        </tr>
                        {/* <tr>
                            <td>Select Background Image: </td>
                            <td>
                                <input type="file" placeholder="Home page background" onChange={(file)=>setFile(file.target.files[0])} accept="image/*" />
                            </td>
                            <td></td>
                            <td>Current Active Image:</td>
                            <td>{currImage &&  <img width={20} src={currImage} alt="logo"/>}</td>
                        </tr> */}
                    </tbody>
                </table>
                <br/><br/>
                
                <br/><br/>
                <h2>Example Theme Images</h2>
                <p style={{fontSize: "12px"}}>Right click and select option to save</p><br/>
                <div style={{display: "flex", gap: "15px"}}>                    
                    <img src={Primary} height="400px" alt="Primary"/>
                    <img src={Spooky} height="400px" alt="Spooky"/>
                    <img src={Christmas} height="400px" alt="Christmas"/>
                    <img src={Candyland} height="400px" alt="Candyland"/>
                </div>

                
            </div>            
        </DashboardComponent>
}